import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import Swal from 'sweetalert2';
import { environment } from '../../../environments/environment';

export interface FuncionComiteAttributes {
  id?: number;
  descripcion: string;
  estado?: number;
  createdAt?: string;
  updatedAt?: string;
}

@Injectable({
  providedIn: 'root'
})
export class FuncionComiteService {

  private apiUrl = `${environment.apiUrl}/api/funcion_comite`;

  constructor(private http: HttpClient) {}

  private manejarError(error: HttpErrorResponse): Observable<never> {
    console.error('❌ Error en la petición:', error);
    let mensaje = 'Ocurrió un error inesperado.';

    if (error.status === 400) {
      mensaje = error.error?.message || 'Datos inválidos.';
    } else if (error.status === 401) {
      mensaje = 'No estás autenticado. Inicia sesión nuevamente.';
      Swal.fire({
        icon: 'warning',
        title: 'Sesión expirada',
        text: mensaje,
        confirmButtonText: 'Ir al login'
      }).then(() => {
        window.location.href = '/login';
      });
      return throwError(() => new Error(mensaje));
    } else if (error.status === 403) {
      mensaje = 'No tienes permisos para realizar esta acción.';
    } else if (error.status === 404) {
      mensaje = 'El registro no fue encontrado.';
    } else if (error.status === 409) {
      mensaje = 'El registro ya existe.';
    } else if (error.status === 500) {
      mensaje = 'Error en el servidor. Inténtalo más tarde.';
    }

    Swal.fire({
      icon: 'error',
      title: 'Error',
      text: mensaje
    });

    return throwError(() => new Error(mensaje));
  }

  // 🔹 Obtener todos
  getAll(): Observable<FuncionComiteAttributes[]> {
    return this.http.get<FuncionComiteAttributes[]>(this.apiUrl, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // 🔹 Obtener por ID
  getById(id: number): Observable<FuncionComiteAttributes> {
    return this.http.get<FuncionComiteAttributes>(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // 🔹 Crear
  create(data: FuncionComiteAttributes): Observable<any> {
    return this.http.post(this.apiUrl, data, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // 🔹 Actualizar
  update(id: number, data: FuncionComiteAttributes): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, data, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }

  // 🔹 Eliminar lógico
  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`, { withCredentials: true })
      .pipe(catchError(this.manejarError));
  }
}
